<template>
  <div class="recharge">
    <h3>充值金额</h3>
    <div class="money">
      <span>￥</span>
      <input type="text" placeholder="请输入充值金额" v-model="money">
    </div>
    <div class="way">
      <p>请选择付款方式</p>
      <div class="wechat">
        <div class="left">
          <img src="../../../assets/images/person/wechat.png" alt="">
          <span>微信支付</span>
        </div>
        <div class="right">
          <img src="../../../assets/images/courier/xuanzhong.png" alt="" v-if="wechat === 0" @click="handleClick(0)">
          <img src="../../../assets/images/courier/meixuan.png" alt="" v-else  @click="handleClick(0)">
        </div>
      </div>
      <div class="pay">
        <div class="left">
          <img src="../../../assets/images/person/pay.png" alt="">
          <span>支付宝</span>
        </div>
        <div class="right">
          <img src="../../../assets/images/courier/xuanzhong.png" alt="" v-if="pay === 1"  @click="handleClick(1)">
          <img src="../../../assets/images/courier/meixuan.png" alt="" v-else  @click="handleClick(1)">
        </div>
      </div>
      <button @click="next">下一步</button>
    </div>
    <p class="text">充值送优惠券说明</p>
    <p class="text">富文本编辑</p>
    <pay-code v-if="isShow" @closeCode="closeCode" />
  </div>
</template>

<script>
import PayCode from '../../../components/Pay/PayCode'
import {mapState} from 'vuex'
export default {
  data () {
    return {
      wechat: 1,
      pay: 0,
      money: '',
      isShow: false // 显示微信支付宝二维码
    }
  },
  methods: {
    // 关闭二维码
    closeCode () {
      this.isShow = false
    },
    handleClick (i){
      if (i === 0) {
        this.wechat = 0
        this.pay = 0
      } else {
        this.wechat = 1
        this.pay = 1
      }
    },
    // 下一步
    next() {
      if(this.wechat === 0) {
        if(this.money) {
          let query = `?totalAmount=${this.money}`
          this.$store.dispatch('getRecharge', query).then(res => {
            console.log(this.orderInfo)
            let query = `?paymentSn=${this.orderInfo.paymentSn}`
            this.$store.dispatch('getWechatPay', query).then(() => {
              this.isShow = !this.isShow
            })
          })
        }
      } else if(this.pay === 1) {
        if(this.money) {
          let query = `?totalAmount=${this.money}`
          this.$store.dispatch('getRecharge', query).then(res => {
            console.log(this.orderInfo)
            let query = `?paymentSn=${this.orderInfo.paymentSn}`
            this.$store.dispatch('getAliPay', query).then(() => {
              this.isShow = !this.isShow
            })
          })
        }
      }
    }
  },
  computed: {
    ...mapState(['orderInfo'])
  },
  components: {
    PayCode
  }
}
</script>

<style scoped lang="less" type="text/less">
.recharge{
  h3{
    font-size: 24px;
    margin-top:60px;
  }
  .money{
    width: 301px;
    margin-top:15px;
    border-bottom: 1px solid #e1e1e1;
    line-height: 40px;
    input{
      width: 282px;
      height: 40px;
      &:focus{
        outline: none;
      }
    }
  }
  .way{
    padding-top:30px;
    p{
      margin-bottom: 20px;
    }
    .wechat, .pay{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 325px;
      height: 63px;
      padding:20px 27px 19px 17px;
      box-sizing: border-box;
      border:1px solid #f1f1f1;
      box-shadow:0px 3px 7px 0px rgba(0, 0, 0, 0.08);
      border-radius:4px;
      margin-bottom: 20px;

      img{
        margin-right: 6px;
        vertical-align: middle;
      }
      &.pay > img{
          margin-right: 14px;
      }
    }
    button{
      width: 192px;
      height: 48px;
      margin-bottom: 33px;
      border:none;
      border-radius:24px;
      box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
      color:#fff;
      font-size: 18px;
      font-weight: bold;
      background: #61aee6;
    }
  }
  .text{
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Recharge.vue